var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_952)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4112 17.666L15.4235 19.4052L9.30649 30.0002L7.55078 26.0846L12.4112 17.666Z",
    fill: "#AA75CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4106 17.6659L9.39827 15.9268L3.28125 26.5218L7.55014 26.0845L12.4106 17.6659Z",
    fill: "#73488D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7076 17.666L13.6953 19.4052L19.8123 30.0002L21.568 26.0846L16.7076 17.666Z",
    fill: "#73488D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 17.6659L19.7193 15.9268L25.8363 26.5218L21.5674 26.0845L16.707 17.6659Z",
    fill: "#AA75CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5544 20.7416C20.282 20.7416 24.9252 16.0985 24.9252 10.3708C24.9252 4.64317 20.282 0 14.5544 0C8.82676 0 4.18359 4.64317 4.18359 10.3708C4.18359 16.0985 8.82676 20.7416 14.5544 20.7416Z",
    fill: "url(#paint0_linear_621_952)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5563 18.466C19.0272 18.466 22.6516 14.8416 22.6516 10.3707C22.6516 5.89979 19.0272 2.27539 14.5563 2.27539C10.0853 2.27539 6.46094 5.89979 6.46094 10.3707C6.46094 14.8416 10.0853 18.466 14.5563 18.466Z",
    fill: "#734C12"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_621_952",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 18,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9853 19.3494C19.4666 19.3494 23.0994 15.7166 23.0994 11.2353C23.0994 6.75393 19.4666 3.12109 14.9853 3.12109C10.5039 3.12109 6.87109 6.75393 6.87109 11.2353C6.87109 15.7166 10.5039 19.3494 14.9853 19.3494Z",
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_621_952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5517 18.4852C19.033 18.4852 22.6658 14.8523 22.6658 10.371C22.6658 5.88967 19.033 2.25684 14.5517 2.25684C10.0703 2.25684 6.4375 5.88967 6.4375 10.371C6.4375 14.8523 10.0703 18.4852 14.5517 18.4852Z",
    fill: "url(#paint1_linear_621_952)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5987 4.72559L16.349 8.22627L19.8497 8.66385L17.4459 11.3594L18.0994 15.2276L14.5987 13.4773L11.098 15.2276L11.7573 11.3594L9.34766 8.66385L12.8484 8.22627L14.5987 4.72559Z",
    fill: "#FFD3BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_952",
    x1: 4.18359,
    y1: 10.3708,
    x2: 24.9252,
    y2: 10.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#944212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09361"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_952",
    x1: 14.5517,
    y1: 2.25684,
    x2: 14.5517,
    y2: 18.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FB9D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/Bronze.3713469b9966e2beb95963c5f1d8c4a4.svg";
export { ForwardRef as ReactComponent };